export interface MenuModelState {
  topMenuCd: string;
}

export const initMenuModel = {
  topMenuCd: 'basis'
};
